/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Section_Denied_TitleInputs */

const en_adm_section_denied_title = /** @type {(inputs: Adm_Section_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission needed`)
};

const de_adm_section_denied_title = /** @type {(inputs: Adm_Section_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigung fehlt`)
};

/**
* | output |
* | --- |
* | "Permission needed" |
*
* @param {Adm_Section_Denied_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_section_denied_title = /** @type {((inputs?: Adm_Section_Denied_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Section_Denied_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_section_denied_title(inputs)
	return en_adm_section_denied_title(inputs)
});